import { UTCDate } from '@date-fns/utc';
export const sectionHasValue = (data) => {
    return Object.keys(data).some((prop) => {
        const value = data[prop];
        if ((Array.isArray(value) && !!value?.length) || (!Array.isArray(value) && !!value)) {
            return true;
        }
        return false;
    });
};
export function combineDateTime(dateStr, timeStr) {
    const [hours, minutes] = timeStr.split(':').map(Number);
    const [year, month, day] = dateStr.split('-').map(Number);
    return new UTCDate(year, month - 1, day, hours, minutes);
}
